import React from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Container } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Collection from './WorkplaceManagementCollection';
import Treatment from './WorkplaceManagementTreatment';

const WorkplaceManagement = () => {
  const type = useSelector((state) => state.auth.user?.type || "")

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>사업장 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="사업장 관리" breadcrumbItem="사업장 관리" />

          {/* { type === 'emitter' && <Emitter/> } */}
          { type === 'collection' && <Collection/> }
          {/* { type === 'driver' && <Driver/> } */}
          { type === 'treatment' && <Treatment/> }
          {/* { type === 'demand' && <Demand/> } */}
          
        </Container>
      </div>
    </React.Fragment>
  )
}

export default WorkplaceManagement
